var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUsWoman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330.14 460.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #412233;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #b07475;\n      }\n\n      .cls-3 {\n        fill: #73617a;\n      }\n\n      .cls-4 {\n        fill: #f49565;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.92,374.15s-3.2,14.89-12.51,21.57c-8.43,6.05-6.95,18.66-6.95,18.66l82.6-38.68-2.69-29.87-60.45,28.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.92,374.15l60.46-28.31-5.46-114.95c-.95-19.96-17.41-35.66-37.39-35.66h0c-22.78,0-40.28,20.18-37.06,42.73l19.45,136.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.9,390.39s-3.2,14.89-12.51,21.57c-8.43,6.05-6.95,18.66-6.95,18.66l82.6-38.68-2.69-29.87-60.45,28.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.9,390.39l60.45-28.31-5.45-132.68c-.95-19.96-17.41-35.66-37.39-35.66h0c-22.78,0-40.28,20.18-37.06,42.73l19.45,153.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.81,
    y: 281.71,
    width: 8.49,
    height: 178.76,
    transform: "translate(238.12 742.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 193.34,
    y: 281.71,
    width: 8.49,
    height: 178.76,
    transform: "translate(395.18 742.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 265.85,
    y: 281.71,
    width: 8.49,
    height: 178.76,
    transform: "translate(540.19 742.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.81,243.28h159.53v26.12c0,6.79-5.52,12.31-12.31,12.31H127.13c-6.79,0-12.31-5.52-12.31-12.31v-26.12h0Z",
    transform: "translate(389.16 525) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.81,243.28h87.02v28.83c0,5.3-4.3,9.6-9.6,9.6h-67.82c-5.3,0-9.6-4.3-9.6-9.6v-28.83h0Z",
    transform: "translate(316.65 525) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 201.84,
    y: 388.49,
    width: 72.51,
    height: 8.49,
    transform: "translate(476.18 785.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.81,
    y: 388.49,
    width: 87.02,
    height: 8.49,
    transform: "translate(316.65 785.48) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 201.84,
    y: 296.31,
    width: 72.51,
    height: 8.49,
    transform: "translate(476.18 601.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 114.81,
    y: 296.31,
    width: 87.02,
    height: 8.49,
    transform: "translate(316.65 601.12) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "187.31 30.29 188.54 39.23 188.97 42.45 190.3 52.07 193.78 77.61 215.95 62.47 212.98 43.17 210.26 25.42 201.43 27.3 187.31 30.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m180.92,52.14c1.34.9,3.08,1.28,4.89.89l4.49-.95,7.12-1.5,1.59-8.29.04-.17,2.83-14.83-.46.03-14.17.71-6.3.31-.08.56-.32,2.14-2.24,15.1c-.4,2.53.73,4.78,2.62,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m180.92,52.14c5.06-6.65,6.13-18.82,6.33-24.13l-6.3.31-.08.56-.32,2.14-2.24,15.1c-.4,2.53.73,4.78,2.62,6.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m247.24,203.79s3.36-1.17,8.68-3.09c16.16-5.81,50.32-18.48,62.34-25.79,13.11-7.97,14.75-21.37,7.95-32.56-.96-1.59-2.09-3.03-3.33-4.3-7.5-7.66-19.53-9.46-29.11-3.71-.03.02-.08.05-.11.07l-62.46,42.94,16.05,26.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m323.36,169.34c-8.98,9.81-24.21,10.47-34.02,1.48l-27.89-25.38-41.89-38.14c-9.79-8.97-10.47-24.2-1.48-34,5.4-5.88,13.04-8.47,20.42-7.66,4.9.54,9.67,2.59,13.58,6.18l30.51,27.77s.01.02.03.05l13.3,12.1,25.94,23.63c9.81,8.98,10.46,24.2,1.5,33.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m271.83,211.15h-109.41l-1.16-108.06c0-9.2-8.67-17.91-3.66-24.85,2.38-3.29,5.21-6.23,8.44-8.71,2.28-1.77,4.76-3.32,7.38-4.58,5.56-2.71,11.81-4.23,18.42-4.23h18.59c15.61,0,27.72,2.63,36.9,9.62,2.85,2.18,5.43,4.76,7.72,7.82.42.54.82,1.1,1.21,1.67,4.08,5.95,7.31,13.53,9.78,23.08l5.78,108.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.55,31.02c.09.22.16.44.25.67,1.26,3.43,4.16,5.84,7.74,7.54,3.09,1.48,6.69,2.4,10.15,3,.1.03.21.04.31.05,7.32,1.21,13.98.89,13.98.89l-2.72-17.75c-.58-7.89-5.75-11.68-14.07-11.68-9.34,0-14.16,7.96-15.22,14.58h-.01s-.08.56-.08.56l-.32,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m183.11,38.06c-.41,2.84.15,5.15,1.27,5.15s2.35-2.3,2.76-5.15c.41-2.84-.15-5.15-1.27-5.15s-2.35,2.3-2.76,5.15Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 221.15,
    cy: 15.53,
    r: 15.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 236.68,
    cy: 32.91,
    r: 9.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 258.51,
    cy: 32.56,
    r: 13.75
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m36.21,81.74l-4.08,7.73-29.8-15.74c-2.13-1.13-2.95-3.77-1.82-5.91h0c1.13-2.13,3.77-2.95,5.91-1.82l29.8,15.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m21.45,80.37l-4.03,37.15c-.34,3.11,2.06,5.89,5.28,5.92,2.28.03,4.22-1.47,5.03-3.53.18-.47.31-.96.36-1.47.14-1.31,1.64-2.01,2.73-1.25l16.12,11.08,1.7,1.17.58.39,18.92-27.52-5.57-3.83-1.8-1.24-2.09-1.43s-10.9-7.49-12.53-8.62l-5.78-3.97c-12.92-9.12-18.62-5.61-18.91-2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.36,128.55s2.64,2.8,6.88,7.18c12.89,13.35,40.5,41.39,53.02,49.99,13.66,9.39,27.58,5.06,35.59-6.59,1.14-1.65,2.06-3.4,2.76-5.19,4.22-10.78.66-23.43-9.24-30.32-.04-.02-.08-.05-.12-.08l-69.97-42.51-18.93,27.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m192.04,72.1c10.72,7.86,13.03,22.93,5.17,33.66l-22.22,30.48-6.06,8.32h-.01s-27.28,37.46-27.28,37.46c-7.86,10.71-22.93,13.02-33.64,5.15-6.44-4.71-9.85-12.03-9.85-19.45.02-4.93,1.53-9.89,4.66-14.17l25.4-34.87.03-.03,9.48-13.03,20.67-28.35c7.86-10.72,22.93-13.03,33.64-5.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 147.36,
    y: 142.2,
    width: 44.83,
    height: 2.43,
    transform: "translate(-46.11 196.17) rotate(-53.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 267.65,
    y: 129.64,
    width: 2.43,
    height: 25.91
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.19,190.37H119.36c-30.5,0-53.98,26.95-49.8,57.16h0s176.27,0,176.27,0c19.07,0,33.37-17.47,29.59-36.17l-4.24-21Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsWoman);
export default __webpack_public_path__ + "static/media/about-us-woman.d5471bf30d140b75c95ebf74e92fc284.svg";
export { ForwardRef as ReactComponent };